import { render } from "./reduction_description.vue?vue&type=template&id=53058d03"
import script from "./reduction_description.vue?vue&type=script&lang=js"
export * from "./reduction_description.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/reduction/info_block/reduction_description.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53058d03"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53058d03', __exports__)) {
    console.log('reload')
    api.reload('53058d03', __exports__)
  }
  
  module.hot.accept("./reduction_description.vue?vue&type=template&id=53058d03", () => {
    console.log('re-render')
    api.rerender('53058d03', render)
  })

}


export default __exports__